export default "__VITE_ASSET__pbqFA3qN__"